export default {
    "advanced": {
        "rangeSeparator": " / ",
        "dateRangePicker": {
            "separator": " / ",
            "from": "Du",
            "to": "Au"
        },
        "rangeInput": {
            "separator": "/"
        },
        "select": {
            "nItems": "{count} éléments sélectionnés",
            "allItems": "Tous les éléments",
            "noItems": "Aucun élément"
        }
    }
};
